module.exports = __webpack_public_path__ + "img/te-34.769a4929.png";